const types = [
    
    {value:1,name:'最高级'},
    {value:2,name:'街道'},
    {value:3,name:'社区'},
    {value:4,name:'部门'},
    {value:-1,name:'通用'},
]

const  PLACE_STATE = {
    2: '三小场所',
    3: '出租房',
    4: '公共场所',
    5: '工业企业',
    6: '大型商业综合体',
    7: '住宅小区'
}
const  Grade = {
    1: 'A级',
    2: 'B级',
    3: 'C级',
    4: 'D级'

    // 1: '重大隐患',
    // 2: '一般隐患',
}

const  IS_PUBLIC = {
    1: '公共的',
    2: '私有的'
}

const getName = (type) => {
    const item = types.find(item => {
        return type == item.value;
    })

    if (item) {
        return item.name;
    } else {
        return '';
    }

}

export {
    types,
    PLACE_STATE,
    Grade,
    IS_PUBLIC,
    getName
}